export const contactStageData = [
  {
    id: "1",
    si_no: "",
    title: "Contacted",
    created_date: "25 Sep 2023, 01:22 pm",
    status: "Active",
    action: "",
    key: "1"
  },
  {
    id: "2",
    si_no: "",
    title: "Not Contacted",
    created_date: "29 Sep 2023, 10:20 pm",
    status: "Active",
    action: "",
    key: "2"
  },
  {
    id: "3",
    si_no: "",
    title: "Closed",
    created_date: "04 Oct 2023, 08:30 am",
    status: "Active",
    action: "",
    key: "3"
  },
  {
    id: "4",
    si_no: "",
    title: "Lost",
    created_date: "17 Oct 2023, 11:45 am",
    status: "Inactive",
    action: "",
    key: "4"
  },
];
